import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { motion } from 'framer-motion';
import heroBg from "../assets/project.jpg";
import p1 from "../assets/p1.webp";
import electrical from "../assets/projectselectrical.jpg";
import firealarm from "../assets/projectfireinst.jpg";
import iot from "../assets/projectiot.jpg";
import ClientsPartners from '../components/ClientsPartners';

const projects = [
    {
        id: 1,
        title: "Construction & Civil Works",
        shortDescription: "Building strong foundations and structures.",
        description: `Our construction and civil works service covers residential, commercial, and industrial projects. 
    We specialize in high-quality foundations, structural works, road construction, and site development 
    with experienced engineers and skilled workers.`,
        image: p1,
    },
    {
        id: 2,
        title: "ICT & IoT Solutions",
        shortDescription: "Innovative tech for smarter environments.",
        description: `We provide cutting-edge ICT and IoT solutions to enhance connectivity and automation. 
    From network setup, device integration, to IoT system deployment, our experts deliver tailored solutions 
    for businesses and smart cities.`,
        image: iot,
    },
    {
        id: 3,
        title: "Electrical Installations",
        shortDescription: "Safe and efficient electrical systems.",
        description: `Our electrical installation services include residential and commercial wiring, lighting systems, 
    power distribution, and maintenance. We ensure compliance with safety standards and energy efficiency.`,
        image: electrical,
    },
    {
        id: 4,
        title: "Fire System Services",
        shortDescription: "Protecting life and property.",
        description: `We design, install, and maintain fire detection and suppression systems. Our services include fire alarms, 
    sprinklers, extinguishers, and emergency response planning to keep your premises safe.`,
        image: firealarm,
    },
];

const steps = [
    {
        title: "Consultation & Planning",
        description: "We understand your needs for construction, ICT, electrical, or fire systems and provide expert guidance.",
    },
    {
        title: "Design & Proposal",
        description: "Our team creates detailed designs and proposals tailored to your project requirements.",
    },
    {
        title: "Implementation",
        description: "Our professionals execute the project efficiently with high-quality workmanship and technology.",
    },
    {
        title: "Testing & Handover",
        description: "We ensure everything works perfectly and hand over a fully functional, safe, and reliable system.",
    },
];

const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
};

function Projects() {
    const [selectedProject, setSelectedProject] = useState(null);

    const navigate = useNavigate();

    return (
        <div className="font-sans w-full">

            <motion.section
                className="relative w-full h-[40vh] bg-cover bg-center flex items-center"
                style={{ backgroundImage: `url(${heroBg})` }}
                initial="hidden"
                animate="visible"
                variants={fadeUpVariant}
                transition={{ duration: 0.8, ease: "easeOut" }}
            >
                <div className="absolute inset-0 bg-black bg-opacity-50"></div>
                <div className="relative z-10 max-w-6xl mx-auto px-6 text-center text-white">
                    <h1 className="font-extrabold mb-6 leading-tight text-[32px] sm:text-[48px]
          ">
                        Delivering Excellence
                    </h1>
                    <p className="mb-8 sm:mb-10 max-w-[90%] sm:max-w-2xl mx-auto
            text-base 
          ">
                        We specialize in construction & civil works, ICT & IoT solutions,
                        electrical installations, and fire system services.
                    </p>

                </div>
            </motion.section>


            <div className="max-w-6xl mx-auto px-4">
                {/* Values Section */}
                {/* <motion.section
                    className="py-12 text-center"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeUpVariant}
                    transition={{ duration: 0.7, delay: 0.2 }}
                >
                    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 leading-snug">
                        Top values for you
                    </h2>
                    <p className="mt-4 text-gray-600 max-w-2xl mx-auto
            text-sm sm:text-base md:text-lg"
                    >
                        Experience the core values that drive every project we deliver
                    </p>
                    <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-6">
                        {[
                            {
                                title: "Safety",
                                desc: "Ensuring protection for people and property."
                            },
                            {
                                title: "Reliability",
                                desc: "Consistent performance in critical environments."
                            },
                            {
                                title: "Innovation",
                                desc: "We  create smarter and more efficient systems."
                            },
                            {
                                title: "Sustainability",
                                desc: "Long-term efficiency and cost-effectiveness."
                            },
                        ].map((value, index) => (
                            <div key={index} className="px-4">
                                <div className="w-12 h-12 mx-auto bg-gray-100 rounded-full flex items-center justify-center mb-4">
                                    <span className="text-lg">🎯</span>
                                </div>
                                <h3 className="font-semibold text-xl">{value.title}</h3>
                                <p className="text-gray-500 mt-2 text-sm md:text-lg">{value.desc}</p>
                            </div>
                        ))}
                    </div>
                </motion.section> */}

                {/* Projects List */}
                <motion.section
                    className="py-12 px-6 lg:px-20"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeUpVariant}
                    transition={{ duration: 0.7, delay: 0.4 }}
                >
                    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 leading-snug pb-3">
                        Our Projects
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                        {projects.map((project) => (
                            <div
                                key={project.id}
                                className="bg-white shadow rounded-xl overflow-hidden hover:shadow-lg transition cursor-pointer"
                                onClick={() => setSelectedProject(project)}
                            >
                                <img
                                    src={project.image}
                                    alt={project.title}
                                    className="w-full h-48 object-cover"
                                />
                                <div className="flex flex-col p-4">
                                    <h3 className="font-semibold text-xl mb-2">{project.title}</h3>
                                    <p className="text-gray-600 text-sm md:text-lg">{project.shortDescription}</p>

                                    <button
                                        onClick={() => setSelectedProject(project)}
                                        className="bg-orange-600 text-white hover:bg-white hover:text-black px-2 py-1 rounded-md hover:underline mt-2 self-start transition"
                                    >
                                        Read more →
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </motion.section>
            </div>

            <section className="py-12 px-4 sm:px-8 md:px-16 max-w-7xl mx-auto text-center mb-10">
                <div className="mb-12">
                    <h3 className="text-2xl sm:text-3xl font-semibold text-gray-800">How We Work</h3>
                    <p className="text-gray-500 mt-2 text-base sm:text-lg">
                        Just in 4 simple steps you can get your consultation
                    </p>
                </div>

                <div className="relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                    {steps.map((step, index) => (
                        <div key={index} className="flex flex-col items-center text-center px-4 relative">

                            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-orange-600 text-white text-lg font-bold mb-4 z-10">
                                {index + 1}
                            </div>

                            <h2 className="text-xl font-semibold text-gray-800 mb-2">{step.title}</h2>
                            <p className="text-gray-500 text-sm sm:text-base">{step.description}</p>

                            {index < steps.length - 1 && (
                                <div className="absolute right-0 top-6 hidden lg:block w-px h-full bg-orange-300 translate-x-1/2"></div>
                            )}
                        </div>
                    ))}
                </div>

                <div className="flex justify-between mt-4 lg:hidden">
                    {steps.map((_, index) => (
                        index < steps.length - 1 && (
                            <div key={index} className="flex-1 h-px bg-orange-300 mx-2"></div>
                        )
                    ))}
                </div>
            </section>

            <ClientsPartners/>


            {selectedProject && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-6"
                    onClick={() => setSelectedProject(null)}
                >
                    <div
                        className="bg-white rounded-lg max-w-5xl w-full p-8 relative"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className="absolute top-3 right-3 text-gray-600 hover:text-gray-900 text-3xl font-bold"
                            onClick={() => setSelectedProject(null)}
                            aria-label="Close modal"
                        >
                            &times;
                        </button>
                        <div className="flex flex-col md:flex-row gap-8">
                            <img
                                src={selectedProject.image}
                                alt={selectedProject.title}
                                className="md:w-1/2 w-full h-96 object-cover rounded"
                            />
                            <div className="md:w-1/2 w-full flex flex-col">
                                <h2 className="text-3xl font-bold mb-4">{selectedProject.title}</h2>
                                <p className="text-gray-700 whitespace-pre-line">{selectedProject.description}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Projects;
